// extracted by mini-css-extract-plugin
module.exports = {"root":"TripCartPanelContent_root__A_rs7"};